import { FORCE_MIXPANEL, MIXPANEL_TOKEN, MODE } from '@infraloop/services'
import mixpanel from 'mixpanel-browser'

// Initialised app-wide rather than inside the editor host, so the signed-out pages — where
// account registration is tracked — have a live client too.
mixpanel.init(MIXPANEL_TOKEN, {
  track_pageview: true,
  persistence: 'localStorage',
  api_host: 'https://api-eu.mixpanel.com',
})

// Local development would otherwise report into the real project.
if (MODE === 'dev') {
  if (!FORCE_MIXPANEL) {
    // eslint-disable-next-line no-console
    console.warn('Mixpanel is disabled in development mode. Set REACT_APP_FORCE_MIXPANEL=true to enable it.')
    mixpanel.disable()
  } else {
    // eslint-disable-next-line no-console
    console.warn('Mixpanel is enabled in development mode due to REACT_APP_FORCE_MIXPANEL=true.')
  }
}
